module.exports = __webpack_public_path__ + "static/media/caio-benegas-congo.7f0afaf4.png";